"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("../Button");
function PagingControl(props) {
    /**
     *  Navigate to the First Page
     */
    function navigateToFirstPage() {
        props.pageRequested(0);
    }
    /**
     *  Navigate to the Previous Page
     */
    function navigateToPreviousPage() {
        var newSkip = Math.max((props.skip - props.top), 0);
        props.pageRequested(newSkip);
    }
    /**
     *  Navigate to the Next Page
     */
    function navigateToNextPage() {
        var newSkip = props.skip + props.top;
        props.pageRequested(newSkip);
    }
    /**
     *  Navigate to the Last Page
     */
    function navigateToLastPage() {
        var lastPageIsEmpty = (props.totalItemCount % props.top) === 0;
        var lastPage = Math.floor(props.totalItemCount / props.top);
        if (lastPageIsEmpty) {
            lastPage = lastPage - 1;
        }
        var newSkip = lastPage * props.top;
        props.pageRequested(newSkip);
    }
    var isPreviousDisabled = props.disabled || (props.skip <= 0);
    var isNextDisabled = props.disabled || ((props.skip + props.top) >= props.totalItemCount);
    var currentPage = Math.ceil((props.skip + props.top) / props.top);
    var totalPages = Math.ceil(props.totalItemCount / props.top);
    if (totalPages === 0) {
        totalPages = 1;
    }
    return (React.createElement("span", { className: 'paging-control' },
        React.createElement(Button_1.Button, { icon: 'double_left', onClick: navigateToFirstPage, disabled: isPreviousDisabled, buttonSize: 'default', buttonType: 'normal' }),
        ' ',
        React.createElement(Button_1.Button, { icon: 'left', onClick: navigateToPreviousPage, disabled: isPreviousDisabled, buttonSize: 'default', buttonType: 'normal' }),
        ' ',
        React.createElement("span", null,
            "Page ",
            currentPage,
            " of ",
            totalPages),
        ' ',
        React.createElement(Button_1.Button, { icon: 'right', onClick: navigateToNextPage, disabled: isNextDisabled, buttonSize: 'default', buttonType: 'normal' }),
        ' ',
        React.createElement(Button_1.Button, { icon: 'double_right', onClick: navigateToLastPage, disabled: isNextDisabled, buttonSize: 'default', buttonType: 'normal' }),
        ' '));
}
exports.PagingControl = PagingControl;
//# sourceMappingURL=PagingControl.js.map